import { ViewAllButtonContainer } from '../../../StoreCategoryPage/ViewAllProducts/styled';

function index(props) {
  const { fetchMoreData } = props;

  return (
    <ViewAllButtonContainer
      onClick={() => {
        fetchMoreData();
      }}
    >
      Load More Products
    </ViewAllButtonContainer>
  );
}

export default index;
